import React from 'react';

export const Heading = ({
  title = '',
  size = '16',
  color = '#1C1C1C',
  weight = '500',
}) => {
  return (
    <p
      style={{
        color: color,
        fontWeight: weight,
        fontSize: size,
        marginBottom: '1rem',
      }}
    >
      {title}
    </p>
  );
};
